<template>
  <div class="ddosWarning app-container" v-loading="loading">
    <div class="global-header-wrap">
      <h3>DDOS预警配置</h3>
      <div class="ddosWarning-header-right">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'ddosWarningAdd' })"
        >
          新增
        </button>
      </div>
    </div>
    <div class="ddosWarning-main">
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <!-- <div slot="header">
        <div class="global-table-header">
          <div class="ddosWarning-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
        </div>
      </div> -->
        <div class="global-body-wrap">
          <TableView
            :tableData="tableData"
            :tableProp="tableProp"
            handleWidth="200"
            :handleBtn="handleBtn"
            @tableHandle="tableHandle"
          />
        </div>
        <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="getPageNum"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import listSearch from '@/components/listSearch'
import TableView from '@/components/tableView'
import Pagination from '@/components/pagination'
export default {
  components: {
    listSearch,
    TableView,
    Pagination
  },
  computed: {
    tableProp() {
      let tableProp = [
        {
          prop: 'title',
          label: '标题'
        },
        {
          prop: 'path',
          label: 'Api'
        },
        {
          prop: 'method',
          label: '方法'
        },
        {
          prop: 'usable',
          label: '是否可用'
        },
        {
          prop: 'createdAt',
          label: '创建时间'
        }
      ]
      return tableProp
    },
    handleBtn() {
      return [
        { style: 'checkDetailsBtn', type: 'edit', title: '编辑' },
        { style: 'delBtn', type: 'del', title: '删除' },
        { style: 'checkDetailsBtn', type: 'open', title: '启用' },
        { style: 'delBtn', type: 'close', title: '禁用' }
      ]
    }
  },
  data() {
    return {
      loading: false,
      params: {
        limit: 20,
        page: 1
      },
      tableData: [],
      total: 0,
      currentItem: null
    }
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        let res = await this.$http.getDDosConfigList(this.params)
        this.tableData = res.data.results
        this.total = res.data.count
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    tableHandle({ type, data }) {
      this.currentItem = data
      switch (type) {
        case 'edit':
          this.$router.push({
            name: 'ddosWarningAdd',
            query: { id: this.currentItem._id }
          })
          break
        case 'del':
          this.del()
          break
        case 'open':
        case 'close':
          this.update(type)
          break

        default:
          break
      }
    },

    async update(type) {
      await this.$confirm(
        type === 'open' ? '将启用此配置' : '将禁用此配置',
        '确定?',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          center: true
        }
      )
      try {
        this.currentItem.usable = !this.currentItem.usable
        await this.$http.updateDDosConfig(
          this.currentItem._id,
          this.currentItem
        )
        this.$message({
          type: 'success',
          message: this.$t('commonMsg.success')
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('commonMsg.failure')
        })
      }
    },

    async del() {
      await this.$confirm('将删除此项配置', '确定删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        center: true
      })
      try {
        await this.$http.delDDosConfig(this.currentItem._id)
        this.getList()
        this.$message({
          type: 'success',
          message: this.$t('commonMsg.success')
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('commonMsg.failure')
        })
      }
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val
      } else {
        delete this.params.name
      }
      this.getList()
    },

    getPageNum(page) {
      this.params.page = page
      this.getList()
    }
  },

  mounted() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.ddosWarning {
  .ddosWarning-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .ddosWarning-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      .ddosWarning-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .ddosWarning-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .ddosWarning-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          > p {
            flex: 1;
          }
          &:hover {
            background: #f3f6f9;
            > .ddosWarning-btn {
              display: block;
            }
          }
          .ddosWarning-btn {
            display: none;
            > i {
              margin-left: 10px;
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
}
</style>
